const VideosIndex = () => import('@pages/marketing/videos/VideosIndex')

export default {
    path: 'marketing',
    component: VideosIndex,
    children: [
        {
            path: 'videos',
            component: VideosIndex,
            name: 'videos',
        }
    ],
}